import { useState, useEffect, useRef } from 'react';
import s from './Header.module.scss';
import ss from '../Button/ShopNowButton/ShopNowButton.module.scss';
import c from './LinkList.module.scss';
import Button from '../Button/CTA/Button';
import { LinkList } from './LinkList';
import { usewpdataSelectors } from '../../lib/wpdataState/selectors';
import Topbar from './Topbar/Topbar';
import { MenuBurger } from './icons/MenuBurger';
import ShoppingCartIcon from '../../assets/icons/ShoppingCartIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [visible, setVisible] = useState(true);
  const answerRef = useRef(null);
  const { header, Settings, Layout } = usewpdataSelectors();

  const getHeight = () => {
    return isMenuOpen ? `${answerRef.current?.scrollHeight}px` : '0';
  };

  const scrollThreshold = 500;

  const handleNavigation = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY < 10) {
      setVisible(true);
    } else if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
      setVisible(false);
    } else if (currentScrollY < lastScrollY) {
      setVisible(true);
    }
    setLastScrollY(currentScrollY);
  };

  const handleZendeskClick = () => {
    window.zE.show();
    window.zE.activate();
  };

  useEffect(() => {
    const controlNavbar = () => {
      window.addEventListener('scroll', handleNavigation);
      return () => {
        window.removeEventListener('scroll', handleNavigation);
      };
    };
    controlNavbar();
  }, [lastScrollY]);

  const buttonClasses = `${ss.shopNowButton} ${s.nav__shopNowButton}`;

  return (
    <>
      <Topbar />
      <header className={s.header}>
        <nav className={s.nav}>
          <div
            className={`${s.nav__navWrap} ${s['nav__navWrap--show']}`}
            style={{
              background: header.styles.background,
              borderColor: header.styles.borderColor,
            }}
          >
            <MenuBurger
              isOpen={isMenuOpen}
              className={s.nav__burger}
              handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle navigation"
            />
            <img
              src={Settings.logo}
              className={s.nav__productLogo}
              alt={Settings.brandName}
              width={149}
              height={30}
              style={{ maxWidth: '100%' }} // Ensure logo doesn't overflow
            />

            <ul className={`${s.linkListDesktop}`}>
              {header.headerNavigationLinks &&
                header.headerNavigationLinks.map((item, index) => {
                  const zendesk = item.custom_link?.custom_link?.includes('zendesk');

                  if (item.link_type !== 'custom') {
                    return (
                      <a key={index} href={item.page_link?.page_link_uri} className={s.linkList__listLink}>
                        <span className={c.listItemText}>{item.page_link?.tr_page_link_label}</span>
                      </a>
                    );
                  }

                  if (item.link_type === 'custom') {
                    if (zendesk) {
                      return (
                        <button
                          key={index}
                          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                          className={c.listItemText}
                          onClick={() => {
                            handleZendeskClick();
                          }}
                        >
                          <span className={c.listItemText} style={{ color: '#404040' }}>
                            {item.custom_link?.tr_custom_link_label}
                          </span>
                        </button>
                      );
                    } else if (item.custom_link?.custom_link?.includes('#')) {
                      const onReviewsClick = () => {
                        setTimeout(() => {
                          const sectionToScroll = document.querySelector(`${item.custom_link.custom_link}`);
                          if (sectionToScroll) {
                            sectionToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
                          }
                        }, 2000);
                      };
                      return (
                        <button
                          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                          key={index}
                          onClick={() => onReviewsClick()}
                          className={s.linkList__listLink}
                        >
                          <span className={c.listItemText}>{item.custom_link?.tr_custom_link_label}</span>
                        </button>
                      );
                    } else {
                      return (
                        <a key={index} href={item.custom_link?.custom_link} className={s.linkList__listLink}>
                          <span className={c.listItemText}>{item.custom_link?.tr_custom_link_label}</span>
                        </a>
                      );
                    }
                  }

                  return null;
                })}
            </ul>
            <div className={s.nav__menuIcons}>
              <ShoppingCartIcon style={{ minWidth: '24px' }} className={s.nav__shoppingCart} />
              <Button
                text={header.headerNavRightButtonText}
                className={buttonClasses}
                style={{ whiteSpace: 'nowrap' }}
              />
            </div>
          </div>
          <ul
            className={`${s.header__navListMobile} ${c.linkList}`}
            style={{
              maxHeight: getHeight(),
              '--offset-mobile': !Layout.middleBar.display ? '94px' : '122px',
            }}
            ref={answerRef}
          >
            <LinkList />
            <div className={s.burgerMenu_cta_wrapper}>
              <Button text={'SHOP NOW'} className={s.burgerMenu_cta} />
            </div>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
